// apps/frontend/src/contexts/ProfilesContext.tsx
// Contexte partagé pour useProfiles — une seule instance pour toute l'app

import React, { createContext, useContext } from 'react'
import useProfiles from '../hooks/profiles/useProfiles'

type ProfilesContextType = ReturnType<typeof useProfiles>

const ProfilesContext = createContext<ProfilesContextType | null>(null)

export function ProfilesProvider({ children }: { children: React.ReactNode }) {
  const profiles = useProfiles()
  return (
    <ProfilesContext.Provider value={profiles}>
      {children}
    </ProfilesContext.Provider>
  )
}

export function useProfilesContext(): ProfilesContextType {
  const ctx = useContext(ProfilesContext)
  if (!ctx) {
    throw new Error('useProfilesContext doit être utilisé dans ProfilesProvider')
  }
  return ctx
}
